<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";

const companyStatuses = {
  0: 'New',
  1: 'Active',
  // 2: 'Suspended'
}

export default {
  page: {
    title: "Clients",
  },
  components: {PageHeader, Layout},
  props: {
  },
  data() {
    return {
      title: 'Clients',
      currentPage: 1,
      perPage: 15,
      sortBy: 'client.status',
      sortDesc: true,
      fields: [
        {key: 'company_name', sortable: true},
        {key: 'country', sortable: true},
        {key: 'client.status', label: 'Status', sortable: true},
      ],
      clients: [],
      filter: 'All',
      searchText: ''
    }
  },
  computed: {
    filteredClients () {
      return this.clients.filter(item => {
          let matchesFilter = this.filter !== 'All' ? item.client.status === this.filter : true;
        return item.company_name.toLowerCase().includes(this.searchText.toLowerCase()) && matchesFilter;
      })
      .map(item => {
        if (item.client.status === 'New') {
          item._rowVariant = 'warning';
        }
        return item
      })
    },
  },
  async created() {
    this.$store.commit('loader/START_LOADING');

    try {
      const {data} = await axios.get('/admin/client');

      data.forEach(item => {
        item.client.status = companyStatuses[item.client.status];
        this.clients.push(item);
      })
    } catch (e) {
      // eslint-disable-next-line no-empty
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  methods: {
    showClient(client) {
      this.$router.push(`/admin/clients/${client._id}`)
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row mb-2">
      <div class="col-12 col-md-6">
        <div class="search-box mr-2">
          <div class="position-relative">
            <input
                    v-model="searchText"
                    type="text"
                    class="form-control border-0"
                    placeholder="Search..."
            />
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 d-flex align-items-center justify-content-end">
        <b-dropdown dropleft variant="info" size="sm">
          <template slot="button-content">
            <i class="mdi mdi-chevron-left"></i>
            Filter by status: {{ filter }}
          </template>
          <b-dropdown-item-button @click="filter = 'New'">New</b-dropdown-item-button>
          <b-dropdown-item-button @click="filter = 'Active'">Active</b-dropdown-item-button>
          <b-dropdown-item-button @click="filter = 'All'">All</b-dropdown-item-button>
        </b-dropdown>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <b-table :items="filteredClients" :fields="fields" striped responsive="sm"
                 :total-rows="clients.length"
                 :per-page="perPage"
                 :current-page="currentPage"
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc"
                 class="border-left border-right border-bottom"
                 selectable
                 @row-clicked="showClient"
        >
        </b-table>

        <b-pagination
            v-model="currentPage"
            :total-rows="filteredClients.length"
            :per-page="perPage"
            aria-controls="my-table"
            class="justify-content-center"
        ></b-pagination>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
  .search-box .form-control {
    border-radius: 0.25rem;
  }
</style>
